import { AlertCircle, CheckCircle2, RotateCcw, X } from "lucide-react";
import { formatBytes, formatEta, formatSpeed } from "@/lib/format";
import { FileIcon } from "@/components/FileIcon";

export function FileRow({ item, onRemove, onRetry, onCancel }) {
  const ext = item.name.includes(".") ? item.name.split(".").pop().toLowerCase() : "";
  return (
    <div className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3" data-testid={`upload-item-${item.id}`}>
      <div className="grid h-11 w-11 shrink-0 place-items-center overflow-hidden rounded-lg bg-slate-100 text-slate-500">
        {item.thumb ? <img src={item.thumb} alt="" className="h-full w-full object-cover" /> : <FileIcon mime={item.file.type} ext={ext} className="h-5 w-5" />}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <p className="truncate text-sm font-medium text-slate-900" data-testid="upload-item-name">{item.name}</p>
          {ext && <span className="shrink-0 rounded bg-slate-100 px-1.5 py-0.5 font-mono text-[10px] uppercase text-slate-500">{ext}</span>}
        </div>
        <p className="mt-0.5 text-xs text-slate-500">
          {item.status === "uploading" ? `${formatBytes(item.loaded)} / ${formatBytes(item.size)} · ${formatSpeed(item.speed)} ${formatEta(item.eta)}` : formatBytes(item.size)}
        </p>
        {item.status === "uploading" && (
          <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-slate-100" role="progressbar" aria-valuenow={item.progress} aria-valuemin={0} aria-valuemax={100}>
            <div className="h-full bg-indigo-600 transition-[width] duration-200" style={{ width: `${item.progress}%` }} />
          </div>
        )}
        {item.status === "error" && <p className="mt-1 flex items-center gap-1 text-xs text-red-600" data-testid="upload-item-error"><AlertCircle className="h-3.5 w-3.5" />{item.error}</p>}
      </div>
      <div className="flex shrink-0 items-center gap-1">
        {item.status === "uploading" && <span className="text-xs font-semibold text-indigo-600" data-testid="upload-item-progress">{item.progress}%</span>}
        {item.status === "done" && <CheckCircle2 className="h-5 w-5 text-emerald-500" />}
        {item.status === "error" && <button onClick={onRetry} className="rounded-full p-1.5 text-slate-500 hover:bg-slate-100" aria-label="Retry" data-testid="upload-item-retry"><RotateCcw className="h-4 w-4" /></button>}
        {item.status === "uploading" ? (
          <button onClick={onCancel} className="rounded-full p-1.5 text-slate-500 hover:bg-slate-100" aria-label="Cancel upload" data-testid="upload-item-cancel"><X className="h-4 w-4" /></button>
        ) : item.status !== "done" ? (
          <button onClick={onRemove} className="rounded-full p-1.5 text-slate-500 hover:bg-slate-100" aria-label="Remove" data-testid="upload-item-remove"><X className="h-4 w-4" /></button>
        ) : null}
      </div>
    </div>
  );
}
